import { render, staticRenderFns } from "./PageWizard.vue?vue&type=template&id=42a12014&scoped=true"
import script from "./PageWizard.vue?vue&type=script&lang=js"
export * from "./PageWizard.vue?vue&type=script&lang=js"
import style0 from "./PageWizard.vue?vue&type=style&index=0&id=42a12014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a12014",
  null
  
)

export default component.exports